import axios from "axios";
import { context, propagation, trace, SpanStatusCode } from "@opentelemetry/api";

const http = axios.create();

http.interceptors.request.use((config) => {
  const tracer = trace.getTracer("axios-tracer");
  const method = (config.method || "GET").toUpperCase();
  const url = config.url || "";
  const span = tracer.startSpan(`HTTP ${method} ${url}`);

  config.headers = config.headers || {};
  propagation.inject(context.active(), config.headers);

  config.metadata = { ...(config.metadata || {}), span };

  return config;
});

http.interceptors.response.use(
  (response) => {
    const span = response.config?.metadata?.span;
    if (span) span.end();
    return response;
  },
  (error) => {
    const span = error.config?.metadata?.span;
    if (span) {
      span.recordException(error);
      span.setStatus({ code: SpanStatusCode.ERROR, message: error.message });
      span.end();
    }
    return Promise.reject(error);
  }
);

export default http;
